export default __webpack_public_path__ + "static/media/studentpic.99ae5a5f.png";